import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components"; // biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
var _excluded = ["className", "isDark", "children", "isFit", "css"];
import cn from "classnames";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
var MetricsCard = function MetricsCard(_ref) {
  var className = _ref.className,
    isDark = _ref.isDark,
    children = _ref.children,
    isFit = _ref.isFit,
    cssProp = _ref.css,
    props = _objectWithoutProperties(_ref, _excluded);
  var minHeightStyles = /*#__PURE__*/css(["\n    min-height: 300px;\n    ", " {\n      min-height: 212px;\n    }\n    ", " {\n      min-height: 240px;\n    }\n  "], function (_ref2) {
    var theme = _ref2.theme;
    return theme.breakpoints.up('sm');
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoints.up('lg');
  });
  return /*#__PURE__*/_jsx(_StyledDiv, _objectSpread(_objectSpread({
    className: cn('w-full h-full flex flex-col  rounded-5', isDark ? 'bg-gray-main-dark-mode text-white' : 'bg-white text-base-dark shadow-tooltip', isFit ? 'p-12' : 'py-16 px-16 sm:py-24 md:px-24', className)
  }, props), {}, {
    $_css: cssProp || css(["\n          ", "\n        "], isFit ? '' : minHeightStyles),
    children: children
  }));
};
export default MetricsCard;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-ot42tk-0"
})(["", ""], function (p) {
  return p.$_css;
});